import Main from "./main/dataSource/api/apiDataSourceMain";

export default class ApiService {
	Main: Main;	
	constructor(cookieName?: string) {
		this.Main = new Main(cookieName);
	}
}
